<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>

    <vs-card>
      <div v-if="selected" class="edit-form">
        <div slot="header">
          <vs-title back>Talep/Şikayet Detayları</vs-title>
        </div>

        <form>
          <vs-input
              class=""
              placeholder="Önceki Sayfadan Etkinlik Seçimi Yapınız"
              label='Etkinlik Adı'
              v-model="selected.eventName"
              title="Title"
              name="title"
              id="title"
              
              disabled
          />
           <br/>
            <br/>
           <vs-input
              class=""
              placeholder="Önceki Sayfadan Etkinlik Seçimi Yapınız"
              label='Form Tipi'
              v-model="selected.suggestRequest"
              title="Title"
              name="title"
              id="title"
              
              disabled
          />

          <br/>
 <br/>
          <div class="aciklama2">
          <vs-textarea
              label='Açıklama'
              v-model="selected.reqq"
              class="aciklama2"
              name="description"
              placeholder="Önceki Sayfadan Etkinlik Seçimi Yapınız"
          />
          </div>
          <div class="form-group">
            <label><strong>Durum:</strong></label>
            {{ obj.columns.published ? "Görüldü" : "Görülmedi" }}
          </div>
        </form>

        <vs-error :errors="errors"></vs-error>

        <vs-button class="butonlar" v-if="obj.columns.published" color="warning" @click="updatePublished(false)">Reddet</vs-button>
        <vs-button class="butonlar" v-else color="#46c93a" @click="updatePublished(true)">Onayla</vs-button>

        <vs-button class="butonlar"  color="#ff4757" @click="deleteItem">Sil</vs-button>

       

       
      </div>

      <div v-else>
        <div slot="header">
          <vs-title back>No Reqq Selected</vs-title>
        </div>

        <p>Please click on a Reqq...</p>
      </div>
    </vs-card>
  </div>

</template>

<script>
  import Reqq from "@/libs/reqqs/Reqq";

  export default {
    name: "reqqs-show",
    title: "View/Edit Reqq",

    data() {
      return {
        obj: new Reqq(),
        loading: false,
        message: ''
      };
    },

    computed: {
      saved() {
        return this.obj.saved
      },

      deleted() {
        return this.obj.deleted
      },

      submitted() {
        return this.obj.form.submitted
      },

      contaminated() {
        return this.obj.form.errorDetected
      },

      errors() {
        return this.obj.form.errors
      },

      selected() {
        return this.obj.selected
      },
    },

    watch: {
      contaminated(val) {
        this.loading = false
      },

      submitted(val) {
        if(val)
          this.loading = false
      },

      saved(val) {
        if(val)
          this.message = 'Etkinlik Talep / Şikayeti Kaydedildi!';
      },

      deleted(val) {
        if(val)
          this.$router.go(-1) // back
      },
    },

    methods: {
      get(id) {
        this.obj.get(id, true);
      },

      updatePublished(status) {
        this.obj.columns.published = status
        return this.update()
      },

      update() {
        this.loading = true
        this.obj.update(this.selected.id, true)
      },

      deleteItem() {
        this.loading = true
        this.obj.delete(this.selected.id)
      }
    },

    mounted() {
      this.message = '';
      this.get(this.$route.params.id);
    }
  };
</script>

<style>
  .edit-form {
     width: 90% ;
    margin: auto;
  }
  .aciklama2{
    width: 90% !important;
  }
  .butonlar{
  margin-left:1%;
}

</style>